var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",on:{"click":function($event){return _vm.logout()}}},[_c('span',{staticClass:"icon fastic-logout",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.localizer.get("Account.Common.Logout")))])
}
var staticRenderFns = []

export { render, staticRenderFns }